import { Control, Controller, FieldValues, Path } from "react-hook-form"
import { Input } from "./input"
import { useEffect, useState } from "react"

interface MoneyInputProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
}

function MoneyInputField({
  value,
  onChange,
  onBlur,
  ref,
}: {
  value: number | undefined
  onChange: (value: number | undefined) => void
  onBlur: () => void
  ref: React.Ref<HTMLInputElement>
}) {
  const [inputValue, setInputValue] = useState(typeof value === "number" ? value.toFixed(2) : "")

  useEffect(() => {
    const formattedValue = typeof value === "number" ? value.toFixed(2) : ""
    setInputValue(formattedValue)
  }, [value])

  return (
    <Input
      ref={ref}
      type="text"
      inputMode="decimal"
      placeholder="-75.00"
      className="h-10 border-0 md:h-auto md:w-24"
      value={inputValue}
      onChange={(e) => {
        setInputValue(e.target.value)
      }}
      onBlur={() => {
        onBlur()
        const num = parseFloat(inputValue)
        if (!isNaN(num)) {
          onChange(num)
        } else {
          onChange(undefined)
        }
      }}
    />
  )
}

function MoneyInput<T extends FieldValues>({ control, name }: MoneyInputProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange, onBlur, ref } }) => (
        <MoneyInputField value={value} onChange={onChange} onBlur={onBlur} ref={ref} />
      )}
    />
  )
}

export { MoneyInput }
